// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../css/common.css';
import '../css/initialConfigStyle.css';

import HeliasLoading1 from '../img/helias-loading-01.png'
import HeliasLoading2 from '../img/helias-loading-02.png'
//import HeliasLoading1 from '../img/helias-loading-01-halloween.png'
//import HeliasLoading2 from '../img/helias-loading-02-halloween.png'

//Variables de autenticación / autorización de peticiones.
const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postListAccountInstallations = endpointHelias+'/Helias/V0/Configuration/postListAccountInstallations';
const putHeliasMonitorCredentials = endpointHelias+'/Helias/V0/Monitor/putHeliasMonitorCredentials';

var initialConfigCommonJS = require("../js/initialConfigCommon.js"); 
var generalCommonJS = require("../js/generalCommon.js");

// InitialCheck
const InitialCheck = () => {    

    useEffect(() => {           

        document.getElementById("labelLoader").innerHTML = "Bienvenid@"

        document.getElementById("labelLoaderInstalacion").innerHTML = "<strong>"+generalCommonJS.obtenerNombreCompletoUsuario()+"</strong>"

        //if(localStorage.getItem("installationName").includes("INSTALADOR")){
        
        if(localStorage.getItem("installationToContinueConfiguration") !== null){
            document.getElementById("labelLoader").innerHTML = "Reanudando la configuración de tu instalación..."            
        }        
                
        //sendEmail() //EMAILING PROVISIONAL DE CONTROL DE ACCESOS BETATESTING
                
        cargaInicial()  
        
      });

    //ENVÍO DE EMAIL PROVISIONAL DURANTE EL BETATESTING PARA TENER MONITORIZADO EL ACCESO EN TIEMPO REAL
    var sendEmail = ()=>{

        var blacklistEmailing = "soporte@fevergy.com"
        var emailUsuarioActual = generalCommonJS.obtenerEmailUsuario()

        if(!blacklistEmailing.includes(emailUsuarioActual) && (emailUsuarioActual.split("@")[1] !== "fevergy.com")){
            
            // Defino los headers de la petición
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
        
            // Defino el JSON de la petición de insercción
            var raw = JSON.stringify({
            "mensaje":emailUsuarioActual+"### ha accedido via "+generalCommonJS.obtenerTipoPlataforma()+" a las "+new Date().toString(),
            "origen": "MONITOR_BETATESTING"
            });
            var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
            };
        
            // realizamos la petición de insercción usando promesas
            fetch(endpointHelias+"/Helias/V0/Messaging/postEmail", requestOptions)
            .then(response => response.text() )
            .then(result => {})
            .catch(error => {});            
        }     
        
    }

    function setearInstalacionesExistentes(jsonGetAccountInstallationsResponse){
    
        var instalacionesDisponibles = ""        
        for (var i = 0; i < jsonGetAccountInstallationsResponse.length; i++) {            
            if(i !== (jsonGetAccountInstallationsResponse.length-1)){
                instalacionesDisponibles += jsonGetAccountInstallationsResponse[i].INSTALLATION_ID+"·"+jsonGetAccountInstallationsResponse[i].InstallationName+"·"+jsonGetAccountInstallationsResponse[i].InitialConfigStatus+"·"+jsonGetAccountInstallationsResponse[i].OWNER+"|"
            }
            else{
                instalacionesDisponibles += jsonGetAccountInstallationsResponse[i].INSTALLATION_ID+"·"+jsonGetAccountInstallationsResponse[i].InstallationName+"·"+jsonGetAccountInstallationsResponse[i].InitialConfigStatus+"·"+jsonGetAccountInstallationsResponse[i].OWNER
            }
         }    
         localStorage.setItem("availableInstallations", instalacionesDisponibles)

    }

    function cargaInicial(){
        
        localStorage.removeItem("installationConfigurationMode")  
        
        var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
        var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
        var lastAuthUserRefreshToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".refreshToken")    
    
        console.log("Inicio la carga inicial")

        //Obtengo la información de las instalaciones del usuario        
        var xhttp = new XMLHttpRequest();
        xhttp.open("POST", postListAccountInstallations, true);
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify({"IdToken": lastAuthUserIdToken});
        xhttp.onreadystatechange = function() {
    
            if (this.readyState === 4 && this.status === 200) {
                
                console.log("Actualización de instalaciones para cuenta actual realizada correctamente.")                                                      
                var jsonGetAccountInstallationsResponse = JSON.parse(this.responseText).body; 
                
                //Actualizo el JSON para que solo contenga los resultados de las instalaciones                
                var numeroInstalaciones = jsonGetAccountInstallationsResponse.length
                localStorage.setItem("currentInstallations",numeroInstalaciones)

                if( numeroInstalaciones === 0){ //Soy nuevo y sin invitaciones
                    console.log("Instalación nueva.")     
                    localStorage.setItem("ongoingInstallationConfiguration", "NEW")
                    //window.location.href = '/UserTypeSelection' // DESCOMENTAR CUANDO SE ABRA A INSTALADORES
                    window.location.href = '/UserInitialConfig/Welcome'

                    //Aquí debería meter llamada a create link

                }    
                else if ( (numeroInstalaciones === 1) || (localStorage.getItem("installationToContinueConfiguration") !== null) ){ //No he terminado de configurar alguna instalación
                        
                    if((localStorage.getItem("installationToContinueConfiguration") === null)){//Tengo una instalación y continuo
                        localStorage.setItem("ongoingInstallationConfiguration", jsonGetAccountInstallationsResponse[0].INSTALLATION_ID)                                
                    }
                    else{//Tengo varias y estoy retomando alguna
                        localStorage.setItem("ongoingInstallationConfiguration", localStorage.getItem("installationToContinueConfiguration"))                                                  
                    }
                    
                    localStorage.removeItem("installationToContinueConfiguration")

                    var estadoConfiguracionInstalacion = ""

                    for (var i = 0; i < jsonGetAccountInstallationsResponse.length; i++) {
                        if(jsonGetAccountInstallationsResponse[i].INSTALLATION_ID === localStorage.getItem("ongoingInstallationConfiguration")){
                            estadoConfiguracionInstalacion = jsonGetAccountInstallationsResponse[i].InitialConfigStatus                    
                            localStorage.setItem("ongoingStepConfiguration", estadoConfiguracionInstalacion)         
                            localStorage.setItem("customizedWorkflow", jsonGetAccountInstallationsResponse[i].InstallationElements) 
                            localStorage.setItem("installationName", jsonGetAccountInstallationsResponse[i].InstallationName)
                            localStorage.setItem("accountID",jsonGetAccountInstallationsResponse[i].ACCOUNT_ID)
                            
                            try{
                                if(jsonGetAccountInstallationsResponse[i].SUBSCRIPTION !== undefined){     
                                    localStorage.setItem("stripeData",JSON.stringify(jsonGetAccountInstallationsResponse[i].SUBSCRIPTION))
                                }
                                else{
                                    localStorage.setItem("stripeData",JSON.stringify({}))
                                }

                            }
                            catch(error){ /* Instalacion sin suscripcion */ }
                            
                        }
                    }

                    if( estadoConfiguracionInstalacion === "WELCOME_USER"){ window.location.href = '/UserInitialConfig/Welcome'; }
                    else if( estadoConfiguracionInstalacion === "WELCOME_INSTALLER"){ window.location.href = '/InstallerInitialConfig/Welcome'; }
                    else if( estadoConfiguracionInstalacion === "GENERAL_INFO_USER"){ window.location.href = '/UserInitialConfig/GeneralInfo'; }
                    else if( estadoConfiguracionInstalacion === "GENERAL_INFO_INSTALLER"){ window.location.href = '/InstallerInitialConfig/GeneralInfo'; }
                    else if( estadoConfiguracionInstalacion === "METEO"){ window.location.href = '/UserInitialConfig/Meteo'; }
                    else if( estadoConfiguracionInstalacion === "INSTALLATION_ELEMENTS"){ window.location.href = '/UserInitialConfig/InstallationElements'; }
                    else if( estadoConfiguracionInstalacion === "FV"){ window.location.href = '/UserInitialConfig/FV'; }
                    else if( estadoConfiguracionInstalacion === "BATTERY"){ window.location.href = '/UserInitialConfig/Battery'; }
                    else if( estadoConfiguracionInstalacion === "GENERATOR"){ window.location.href = '/UserInitialConfig/Generator'; }
                    else if( estadoConfiguracionInstalacion === "CARS"){ window.location.href = '/UserInitialConfig/Cars'; }
                    else if( estadoConfiguracionInstalacion === "DEVICES"){ window.location.href = '/UserInitialConfig/Devices'; }                    
                    else if( estadoConfiguracionInstalacion === "MESSAGING_USER"){ window.location.href = '/UserInitialConfig/Messaging'; }                  
                    else if( estadoConfiguracionInstalacion === "MESSAGING_INSTALLER"){ window.location.href = '/InstallerInitialConfig/Messaging'; }                  
                    else if( estadoConfiguracionInstalacion === "FINAL_INFO"){ window.location.href = '/UserInitialConfig/FinalStep'; }
                    else if( estadoConfiguracionInstalacion === "COMPLETED_USER"){ 
                    
                        if(localStorage.getItem("deepLinkID") !== null){
                            localStorage.setItem("installationId",localStorage.getItem("deepLinkID"))
                        }
                        else{
                            localStorage.setItem("installationId",localStorage.getItem("ongoingInstallationConfiguration"))
                        }                        
                        
                        setearInstalacionesExistentes(jsonGetAccountInstallationsResponse)
                        
                        //Actualizo las credenciales del monitor
                        var xhttp2 = new XMLHttpRequest();
                        xhttp2.open("PUT", putHeliasMonitorCredentials, true);        
                        xhttp2.setRequestHeader('Content-Type', "application/json");
                        xhttp2.setRequestHeader('Authorization', lastAuthUserIdToken);
                        var data2 = JSON.stringify({"lastIdToken": lastAuthUserIdToken,"lastRefreshToken": lastAuthUserRefreshToken});
                        xhttp2.onreadystatechange = function() {            
                            if (this.readyState === 4 && this.status === 200) {                                  
                                console.log("Actualización de credenciales de MONITOR realizada correctamente.")   
                                
                                var jsonRespuestaMonitorCredenciales = JSON.parse(this.responseText)
                                localStorage.setItem("lastAccess",jsonRespuestaMonitorCredenciales.body.lastAccess)
                                
                                window.location.href = '/Dashboard';      
                            }            
                            if (this.readyState === 4 && this.status !== 200) {                
                                console.log("Error en la inicialización de las credenciales del monitor.")      
                                initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)
                            }            
                        };
                        xhttp2.send(data2);
                        
                    }
                    else if( estadoConfiguracionInstalacion === "COMPLETED_INSTALLER"){                                        
                        localStorage.setItem("installationId",localStorage.getItem("ongoingInstallationConfiguration"))                        
                        setearInstalacionesExistentes(jsonGetAccountInstallationsResponse)    

                        localStorage.setItem("installerMode", "true")
                        
                        localStorage.setItem("lastAccess","")

                        if(localStorage.getItem("deepLinkID") !== null){
                            window.location.href = '/InstallerDashboard?iID='+localStorage.getItem("deepLinkID");                                           
                        }   
                        else{
                            window.location.href = '/InstallerDashboard';                                           
                        }                     
                        
                    }                                                   
                }
                else{

                    var ultimaInstalacionUtilizada = ""

                    if(localStorage.getItem("deepLinkID") !== null){

                        ultimaInstalacionUtilizada = localStorage.getItem("deepLinkID")

                        for (var x = 0; x < numeroInstalaciones; x++) {

                            if( jsonGetAccountInstallationsResponse[x].INSTALLATION_ID === ultimaInstalacionUtilizada){

                                ultimaInstalacionUtilizada = jsonGetAccountInstallationsResponse[x].INSTALLATION_ID
                                localStorage.setItem("customizedWorkflow", jsonGetAccountInstallationsResponse[x].InstallationElements) 
                                localStorage.setItem("installationName", jsonGetAccountInstallationsResponse[x].InstallationName)
                                localStorage.setItem("accountID",jsonGetAccountInstallationsResponse[x].ACCOUNT_ID)
                                
                                if(jsonGetAccountInstallationsResponse[x].SUBSCRIPTION !== undefined){                                
                                    localStorage.setItem("stripeData",JSON.stringify(jsonGetAccountInstallationsResponse[x].SUBSCRIPTION))
                                }
                                else{
                                    localStorage.setItem("stripeData",JSON.stringify({}))
                                }

                                break
                            }

                        }

                    }


                    // Aun así si fallara por algo el deeplink (Ej: logado con otra cuenta que no tenga esa instalación) reviso las que tengo y acceso a la última utilizada                    
                    if(ultimaInstalacionUtilizada === ""){

                        //Compruebo si hay alguna instalación sin terminar la configuración y la retomo
                        var hayInstalacionesSinTerminarDeConfigurar = false

                        for (var y = 0; y < numeroInstalaciones; y++) {

                            if(!jsonGetAccountInstallationsResponse[y].InitialConfigStatus.includes("COMPLETED")){
                                hayInstalacionesSinTerminarDeConfigurar = true

                                ultimaInstalacionUtilizada = jsonGetAccountInstallationsResponse[y].INSTALLATION_ID
                                localStorage.setItem("customizedWorkflow", jsonGetAccountInstallationsResponse[y].InstallationElements) 
                                localStorage.setItem("installationName", jsonGetAccountInstallationsResponse[y].InstallationName)
                                localStorage.setItem("accountID",jsonGetAccountInstallationsResponse[y].ACCOUNT_ID)
                                
                                if(jsonGetAccountInstallationsResponse[y].SUBSCRIPTION !== undefined){                                
                                    localStorage.setItem("stripeData",JSON.stringify(jsonGetAccountInstallationsResponse[y].SUBSCRIPTION))
                                }
                                else{
                                    localStorage.setItem("stripeData",JSON.stringify({}))
                                }

                                if(!jsonGetAccountInstallationsResponse[y].InitialConfigStatus.includes("COMPLETED")){
                                    localStorage.setItem("installationToContinueConfiguration",jsonGetAccountInstallationsResponse[y].INSTALLATION_ID)
                                    window.location.href = '/'            
                                }                                    

                                break

                            }


                            if( (jsonGetAccountInstallationsResponse[y].LastUsedInstallation === "true") && jsonGetAccountInstallationsResponse[y].InitialConfigStatus === "COMPLETED_USER" ){

                                ultimaInstalacionUtilizada = jsonGetAccountInstallationsResponse[y].INSTALLATION_ID
                                localStorage.setItem("customizedWorkflow", jsonGetAccountInstallationsResponse[y].InstallationElements) 
                                localStorage.setItem("installationName", jsonGetAccountInstallationsResponse[y].InstallationName)
                                localStorage.setItem("accountID",jsonGetAccountInstallationsResponse[y].ACCOUNT_ID)
                                
                                if(jsonGetAccountInstallationsResponse[y].SUBSCRIPTION !== undefined){                                
                                    localStorage.setItem("stripeData",JSON.stringify(jsonGetAccountInstallationsResponse[y].SUBSCRIPTION))
                                }
                                else{
                                    localStorage.setItem("stripeData",JSON.stringify({}))
                                }

                                if(!jsonGetAccountInstallationsResponse[y].InitialConfigStatus.includes("COMPLETED")){
                                    localStorage.setItem("installationToContinueConfiguration",jsonGetAccountInstallationsResponse[y].INSTALLATION_ID)
                                    window.location.href = '/'            
                                }                                    

                                break

                            }                            




                        }

                        if(hayInstalacionesSinTerminarDeConfigurar === false){

                            //Compruebo cual es la última utilizada en caso de que todas estén inicializadas
                            for (y = 0; y < numeroInstalaciones; y++) {

                                if( (jsonGetAccountInstallationsResponse[y].LastUsedInstallation === "true") && jsonGetAccountInstallationsResponse[y].InitialConfigStatus === "COMPLETED_USER" ){

                                    ultimaInstalacionUtilizada = jsonGetAccountInstallationsResponse[y].INSTALLATION_ID
                                    localStorage.setItem("customizedWorkflow", jsonGetAccountInstallationsResponse[y].InstallationElements) 
                                    localStorage.setItem("installationName", jsonGetAccountInstallationsResponse[y].InstallationName)
                                    localStorage.setItem("accountID",jsonGetAccountInstallationsResponse[y].ACCOUNT_ID)
                                    
                                    if(jsonGetAccountInstallationsResponse[y].SUBSCRIPTION !== undefined){                                
                                        localStorage.setItem("stripeData",JSON.stringify(jsonGetAccountInstallationsResponse[y].SUBSCRIPTION))
                                    }
                                    else{
                                        localStorage.setItem("stripeData",JSON.stringify({}))
                                    }

                                    if(!jsonGetAccountInstallationsResponse[y].InitialConfigStatus.includes("COMPLETED")){
                                        localStorage.setItem("installationToContinueConfiguration",jsonGetAccountInstallationsResponse[y].INSTALLATION_ID)
                                        window.location.href = '/'            
                                    }                                    

                                    break

                                }
                            }

                            if(ultimaInstalacionUtilizada === ""){ //Si por algún motivo no tengo ninguna a true (e.j: le descomparten la última usada) elijo la primera que tenga
                                ultimaInstalacionUtilizada = jsonGetAccountInstallationsResponse[0].INSTALLATION_ID
                                localStorage.setItem("customizedWorkflow", jsonGetAccountInstallationsResponse[0].InstallationElements) 
                                localStorage.setItem("installationName", jsonGetAccountInstallationsResponse[0].InstallationName)
                                localStorage.setItem("accountID",jsonGetAccountInstallationsResponse[0].ACCOUNT_ID)

                                if(jsonGetAccountInstallationsResponse[0].SUBSCRIPTION !== undefined){                                
                                    localStorage.setItem("stripeData",JSON.stringify(jsonGetAccountInstallationsResponse[0].SUBSCRIPTION))
                                }
                                else{
                                    localStorage.setItem("stripeData",JSON.stringify({}))
                                }
                            }
                        }

                    }

                    var nombreInstalacion = localStorage.getItem("installationName").split("*")[1]
                    
                    if(localStorage.getItem("installationName").includes("INSTALADOR")){
                        document.getElementById("labelLoader").innerHTML = "Accediendo a la instalación"
                    } 
                    else{
                        document.getElementById("labelLoader").innerHTML = "Accediendo a tu instalación"
                    }
                    

                    if(nombreInstalacion !== undefined){
                        document.getElementById("labelLoaderInstalacion").innerHTML = "<strong>"+nombreInstalacion+"</strong>"
                    }
                    console.log("Tengo varias instalaciones e inicio la actualización de las credenciales del monitor.")      
                    console.log("2 o mas")


                    //Actualizo las credenciales del monitor
                    var xhttp3 = new XMLHttpRequest();
                    xhttp3.open("PUT", putHeliasMonitorCredentials, true);        
                    xhttp3.setRequestHeader('Content-Type', "application/json");
                    xhttp3.setRequestHeader('Authorization', lastAuthUserIdToken);
                    var data3 = JSON.stringify({"lastIdToken": lastAuthUserIdToken,"lastRefreshToken": lastAuthUserRefreshToken});
                    xhttp3.onreadystatechange = function() {            
                        if (this.readyState === 4 && this.status === 200) {                                  
                            console.log("Actualización de credenciales de MONITOR realizada correctamente.")
                            localStorage.removeItem("ongoingInstallationConfiguration")
                            localStorage.setItem("installationId",ultimaInstalacionUtilizada) 
                            setearInstalacionesExistentes(jsonGetAccountInstallationsResponse)                       

                            var jsonRespuestaMonitorCredenciales = JSON.parse(this.responseText)
                            localStorage.setItem("lastAccess",jsonRespuestaMonitorCredenciales.body.lastAccess)

                            window.location.href = '/Dashboard'                            
                        }            
                        if (this.readyState === 4 && this.status !== 200) {                
                            console.log("Error en la inicialización de las credenciales del monitor.")      
                            initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)
                        }            
                    };
                    xhttp3.send(data3);

                }
            }

            if (this.readyState === 4 && this.status !== 200) {                     
                console.log("Error al leer las instalaciones de la cuenta.")                  
                initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)                
            }            
        };
        xhttp.send(data);
        
        console.log("Termino la carga inicial")
    }


    return (
        <main>
            <div className="loader initialcheck">
                <div className="first-loading" >
                    <img className="mask" src={HeliasLoading2} alt=""/>
                    <img src={HeliasLoading1} alt=""/>
                </div>
                <label id="labelLoader"></label>
                <p id="labelLoaderInstalacion"></p>
            </div>                    
        </main>                          
    )
}

export default InitialCheck